import moment from "moment";

const ISO_DOB_REGEX = /^\d{4}-\d{2}-\d{2}$/;

/**
 * Parse patient date_of_birth from API (often ISO YYYY-MM-DD) or legacy UI formats.
 * Order matters: ISO strict first so values like 1988-01-30 are not misread by DD-MM-YYYY.
 */
export const parsePatientDateOfBirthMoment = (birthDate, preferredFormat = "DD/MM/YYYY") => {
	if (birthDate == null || birthDate === "") {
		return moment.invalid();
	}
	const s = String(birthDate).trim();
	if (!s) {
		return moment.invalid();
	}
	if (s.toUpperCase() === "REDACTED") {
		return moment.invalid();
	}

	if (ISO_DOB_REGEX.test(s)) {
		return moment(s, "YYYY-MM-DD", true);
	}

	const strictAttempts = [
		() => moment(s, "YYYY-MM-DD", true),
		() => moment(s, preferredFormat, true),
		() => moment(s, "DD/MM/YYYY", true),
		() => moment(s, "DD-MM-YYYY", true),
	];
	for (const tryParse of strictAttempts) {
		const m = tryParse();
		if (m.isValid()) {
			return m;
		}
	}

	let m = moment(s, preferredFormat);
	if (m.isValid()) {
		return m;
	}

	m = moment(s, ["DD-MM-YYYY", "D-M-YYYY", "DD/MM/YYYY", "D/M/YYYY", "YYYY-MM-DD"], true);
	if (m.isValid()) {
		return m;
	}

	m = moment(s, ["DD-MM-YYYY", "D-M-YYYY", "DD/MM/YYYY", "D/M/YYYY"], false);
	if (m.isValid()) {
		return m;
	}

	const loose = moment(s);
	return loose.isValid() ? loose : moment.invalid();
};
